import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const facts = [{
  value: 'Local',
  label: 'Family hosted'
}, {
  value: 'Quiet',
  label: 'Surrounded by nature'
}, {
  value: 'Dining',
  label: 'Breakfast included · lunch & dinner on request'
}];
export function Intro() {
  return <section id="intro" className="w-full bg-ivory pb-24 sm:pb-28 lg:pb-36" data-id="element-168" data-mp="2ghybfw95njgd">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1fr] lg:gap-20 lg:px-12" data-id="element-169" data-mp="1sqsvzi74mt6l">
        <Reveal data-id="element-170" data-mp="1ntairfm2trss">
          <SectionLabel data-id="element-171" data-mp="1ntkd1fe5ml4a">The Homestay</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2.25rem,5vw,4rem)] font-light leading-[1.05] text-forest-deep" data-id="element-172" data-mp="22gvl37b4nmzn">
            More than a place
            <span className="block italic text-ocean" data-id="element-173" data-mp="1xoucpwh2ygew">to stay</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-174" data-mp="19z9sla96xd41">
          <p className="max-w-xl text-[17px] leading-[1.85] text-forest-deep/70" data-id="element-175" data-mp="19yhw7x7rrbcp">
            Experience Taveuni from a peaceful local home surrounded by tropical
            nature. Enjoy a comfortable stay, homemade breakfast, and an
            authentic way to discover one of Fiji's most beautiful islands.
          </p>

          <dl className="mt-10 grid max-w-md grid-cols-3 gap-6 border-t border-sand-dark/50 pt-8" data-id="element-176" data-mp="bgeuzv8a5bu8">
            {facts.map(item => <div key={item.value} data-id="element-177" data-mp="fggsds6zfj3p">
                <dt className="font-serif text-2xl text-ocean" data-id="element-178" data-mp="fjl0v1rhd106">{item.value}</dt>
                <dd className="mt-1 text-[12px] uppercase tracking-[0.12em] text-forest-deep/50" data-id="element-179" data-mp="3eyq2kjolg83a">
                  {item.label}
                </dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}